import styled from 'styled-components'

export interface SiteLogoSCProps {}

export const SiteLogoSC = styled.img<SiteLogoSCProps>`
  width: 205px;
`
